export default "__VITE_PUBLIC_ASSET__e02f459e__"